import { createStore, combineReducers, compose } from 'redux';

import type { RailsContext } from '../types/react-on-rails';

import type { ObjectType } from '../types/misc';
import type { Store } from 'redux';

import pageState from '../reducers/stencil_builder/pageState';
import settings from '../reducers/stencil_builder/settings';
import submission from '../reducers/stencil_builder/submission';
import cache from '@src/reducers/wysiwyg_editor/cache';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: typeof compose;
  }
}

export default (props: ObjectType = {}, _railsContext: RailsContext): Store => {
  let store: Store;
  const reducers = {
    cache,
    pageState,
    settings,
    submission
  };

  const combinedReducers = combineReducers(reducers);

  if (typeof window === 'undefined') {
    store = createStore(combinedReducers, props);
  } else {
    store = createStore(
      combinedReducers,
      props,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()
    );
  }

  return store;
};
